import { render, staticRenderFns } from "./rompecabezas2.vue?vue&type=template&id=4c345949&scoped=true"
import script from "./rompecabezas2.vue?vue&type=script&lang=js"
export * from "./rompecabezas2.vue?vue&type=script&lang=js"
import style0 from "./rompecabezas2.vue?vue&type=style&index=0&id=4c345949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c345949",
  null
  
)

export default component.exports